// extracted by mini-css-extract-plugin
module.exports = {"board":"LogoBoard-module--board--3Tu3q","logo":"LogoBoard-module--logo--26oU-"};